export function isCartPage() {
  return window.location.pathname.indexOf('/cart') > -1;
}
